import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { BaseDialogProps } from './BaseDialogProps'
import ConfirmButton from '../Button/ConfirmButton'

type CopyConfirmationDialogProps = BaseDialogProps & {
  copySelectedHours: () => void
  isLoading: boolean
}

const CopyConfirmationDialog = ({ copySelectedHours, open, onClose, isLoading }: CopyConfirmationDialogProps) => {

  const handleConfirmCopy = () => {
    copySelectedHours()
    onClose?.()
  }

  return (
    <Dialog
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          paddingLeft: 1,
          paddingRight: 2,
          paddingTop: 1,
          paddingBottom: 2,
        },
      }}
    >
      <DialogTitle>{t('page.schedule.confirmCopyDialog.title')}</DialogTitle>
      <DialogContent>
        <Stack direction="column">
          <Typography component="span">{t('page.schedule.confirmCopyDialog.content')}</Typography>
          <Typography component="span" sx={{ fontStyle: 'italic', pt: 1, color: 'warning.main' }}>
            {t('page.schedule.confirmCopyDialog.warning')}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ gap: 2 }}>
        <Button onClick={onClose} size="small">
          {t('page.schedule.confirmCopyDialog.return')}
        </Button>
        <ConfirmButton 
          text={t('page.schedule.confirmCopyDialog.confirm')} 
          onClick={handleConfirmCopy} 
          isDisabled={isLoading}
        />
      </DialogActions>
    </Dialog>
  )
}

export default CopyConfirmationDialog